const firebaseConfig = {
  apiKey: "AIzaSyAMwZFdUsOjHqTvGJK3nxI-etGdJSaoXJw",
  authDomain: "fooddelivery-dd855.firebaseapp.com",
  projectId: "fooddelivery-dd855",
  storageBucket: "fooddelivery-dd855.appspot.com",
  messagingSenderId: "247755516753",
  appId: "1:247755516753:web:4f795a974607e14f40c170",
};

export default firebaseConfig;
